import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Home from './pages/Home';
import Logs from './pages/Logs';
import Collection from './pages/Collection';
import CollectionDetail from './pages/CollectionDetail';
import Builder from './pages/Builder';
import Filters from './pages/Filters';
import Telegram from './pages/Telegram';
import Stats from './pages/Stats';
import Exports from './pages/Exports';
import Settings from './pages/Settings';

function authed() {
  return !!localStorage.getItem('token');
}

function Private() {
  if (!authed()) return <Navigate to="/login" replace />;
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="rm-main">
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route
          path="/login"
          element={authed() ? <Navigate to="/" replace /> : <Login />}
        />
        <Route element={<Private />}>
          <Route path="/" element={<Home />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/collection/:id" element={<CollectionDetail />} />
          <Route path="/builder" element={<Builder />} />
          <Route path="/filters" element={<Filters />} />
          <Route path="/telegram" element={<Telegram />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/exports" element={<Exports />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to={authed() ? '/' : '/login'} replace />} />
      </Routes>
    </Router>
  );
}
